module.exports = __webpack_public_path__ + "static/media/04.1bb90c44.jpg";